import { routeConf } from 'Config';
import { createApiRequest } from './lib';

const getCards = createApiRequest(routeConf.cardPath, 'GET');
const noop = () => {};

export {
  getCards, noop,
};
